import { render, staticRenderFns } from "./MainTabs.vue?vue&type=template&id=f03c6346&scoped=true&"
import script from "./MainTabs.vue?vue&type=script&lang=js&"
export * from "./MainTabs.vue?vue&type=script&lang=js&"
import style0 from "./MainTabs.vue?vue&type=style&index=0&id=f03c6346&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03c6346",
  null
  
)

export default component.exports